<template>
    <div class="render-post render-post-telegram" :class="scrollbarClass" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

       
        <div class="post-header">
            <div></div>
            <p class="name">{{ pages.length == 1 ? pages[0].name : 'Groupe' }}</p>
            <div class="img-pages">

                <template v-for="(page,index) in visiblePages">
                    <Tooltip :key="index" :active="page.iconEdited" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`" @click="() => onClickAvatar(page, index)">
                        <img :src="page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                    </Tooltip>
                </template>

                <ContextMenu
                    v-if="pages.length > 4"
                    :options="hiddenPagesOptions"
                    id="contextMenuHiddenPagesTelegram"
                    v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                >
                    <div class="page count">
                        +{{ pages.length - 3 }}
                    </div>
                </ContextMenu>
            </div>
        </div>
        <div class="conversation hide-scrollbar">
            <div class="date">
                <p>{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
            </div>
            <div class="post-content" v-if="text || snippet.link">
                <div class="post-text">
                    <p v-html="textTranslateMentionAndHastag"></p>
                </div>

                <div class="snippet" v-if="snippet.link">
                    <SnippetNetwork :link="snippet.link"></SnippetNetwork>
                </div>
          
       
            </div>


            <div class="post-content" v-for="comment in commentsTranslateMentionAndHastag">
                <div class="post-text">
                    <p v-html="comment"></p>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip,
            ContextMenu
        },

        props: {
            pages: {
                type: Array,
                default: () => [] 
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: () => [] 
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },


            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        methods: {
            // pas de page RS externe à ouvrir pour Telegram : la page du haut de pile
            // émet toujours clickPage (édition ou simple affichage), seules les autres
            // pages de la pile passent au premier plan au lieu de déclencher une action
            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                this.$emit('clickPage', page.id)
            }
        },

        computed: {
            visiblePages() {
                return this.pages.slice(0, this.pages.length == 4 ? 4 : 3)
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },

            formatDatePost: function(){
                if(this.datePost == false) return '';
                let dateNow = new Date()
                let dateFuture = new Date(this.datePost)

                const addHours = (dateString) => (`${dateString} à ${dateFuture.getHours()}h${dateFuture.getMinutes().toString().padStart(2, '0')}`)
        
                if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                    if (Math.abs(Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24))) < 7) {
                        if (dateFuture.getDay() === dateNow.getDay()) return addHours("Aujourd'hui")
                        if (dateFuture.getDay() === dateNow.getDay()+1) return addHours("Demain")
                        if (dateFuture.getDay() === dateNow.getDay()-1) return addHours("Hier")
                        return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long' }));
                    }
                
                    if(dateFuture.getMonth() === dateNow.getMonth()) return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric'}));

                    return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { weekday: 'long', day: 'numeric', month: 'numeric' }));
                }
                return addHours(dateFuture.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }));
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.telegram ? `<span class="mention">@${mention.mention.telegram.id || mention.mention.telegram.name}</span>` : mention.textDefault;
                    }
                    return match;
                })
                .replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/ig, "<a href='$1' target='_blank'>$1</a>")
                .replace(/\n/g, '<br>');
              
            },

            commentsTranslateMentionAndHastag() {
                return this.comments.map(comment => (
                    comment.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {
                        const mention = this.mentions[id];
                        if (mention) {
                            return mention.mention && mention.mention.telegram ? `<span class="mention">@${mention.mention.telegram.id || mention.mention.telegram.name}</span>` : mention.textDefault;
                        }
                        return match;
                    }).replace(/\n/g, '<br>')
                ))
            }
          
        },
    }
</script>
